import React from 'react';
import { useAppStateContext } from 'src/AppState/AppState';
import { useCommon } from 'src/AppState/Common';
import { BonusCreationState } from 'src/domains/casino/webview/bonus-engine/bonus-creator/bonus-creation/BonusCreation.state';
import { BonusCreationViewManager } from 'src/domains/casino/webview/bonus-engine/bonus-creator/bonus-creation/BonusCreationViewManager';
import { TabList, TabTrigger } from 'src/domains/common/components/tabs/tabs';
import { observer } from 'src/utils/mobx-react';

export type BonusCreationTabListPropsType = {
    bonusCreationId?: string;
    bonusRewardState: BonusCreationViewManager;
};

export const BonusCreationTabList = observer(
    'BonusCreationTabList',
    ({ bonusCreationId, bonusRewardState }: BonusCreationTabListPropsType): JSX.Element => {
        const { routerBackoffice } = useAppStateContext();
        const common = useCommon();
        const bonusCreationState = BonusCreationState.get(common, bonusCreationId);

        const list: Array<JSX.Element> = [];

        for (const viewItem of bonusRewardState.bonusRewardsViewsList) {
            list.push(
                <TabTrigger
                    key={viewItem.id}
                    onClick={() => {
                        bonusRewardState.navigateToView(viewItem.value);
                    }}
                    active={viewItem.value === routerBackoffice.bonusCreationParams?.view}
                    notifications={bonusCreationState.bonusRewardTabsErrors[viewItem.id]}
                >
                    {viewItem.label}
                </TabTrigger>
            );
        }

        return <TabList>{list}</TabList>;
    }
);
